// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UlSf","image":"Header_image__ApZiW","name":"Header_name__354Ez","info":"Header_info__2jZBe","infoRow":"Header_infoRow__1g64N"};